<template>
  <div class="clientInfo">
    <Loading v-if="loading" />
    <div class="clientInfo__header">
      <p>{{ $t('clientInformation') }}</p>
    </div>
    <div class="clientInfo__main">
      <div class="info">
        <p>{{ $t('mobilePhone') }}</p>
        <span>{{ viewOrder?.clientInfo.phoneNumber }}</span>
      </div>
      <div class="info">
        <p>{{ $t('fullName') }}</p>
        <span
          >{{ viewOrder?.clientInfo.firstName }}
          {{ viewOrder?.clientInfo.lastName }}</span
        >
      </div>
      <div class="info">
        <p>{{ $t('ssn') }}</p>
        <span>
          {{ !showDecodedSSN ? '************' : decodedSSN?.ssn }}
        </span>
        <Button
          class="ssn_btn"
          variant="notBordered"
          :title="!showDecodedSSN ? $t('show') : $t('hide')"
          @click="initSSN()"
        />
      </div>
      <div v-if="viewOrder?.clientInfo.homeAddress" class="info">
        <p>{{ $t('homeAddress') }}</p>
        <span>{{ viewOrder.clientInfo.homeAddress }}</span>
      </div>
      <div class="consentGiven">
        <Checkbox name="consentGiven" :value="consentGiven" />
        <span>
          {{ $t('consentGivenText') }}
        </span>
      </div>
      <div class="info">
        <p>{{ $t('timestamp') }}</p>
        <span>{{ dateTimeResult(viewOrder?.createdTime) }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

import { Params } from '@/store/modules/users/types';

import { dateTimeResult } from '@/utils/tableFunctions';

@Options({
  name: 'ClientInfo',
  props: ['viewOrder'],
  components: {
    Loading
  },
  data() {
    return {
      dataSSN: '',
      loading: false,
      showDecodedSSN: false,
      consentGiven: true
    };
  },
  computed: {
    ...mapState('orders', ['decodedSSN'])
  },
  methods: {
    ...mapActions('orders', ['getOrdersHistoryDecodedSSN']),
    async initSSN() {
      const { pharmacyId } = this.$route.params;

      const params: Params = {
        pharmacyId,
        orderId: this.viewOrder.id
      };

      this.showDecodedSSN = !this.showDecodedSSN;

      if (this.showDecodedSSN) {
        this.loading = true;

        await this.getOrdersHistoryDecodedSSN(params);

        this.dataSSN = this.decodedSSN?.ssn;
        this.loading = false;
      }
    },
    dateTimeResult
  }
})
export default class ClientInfo extends Vue {}
</script>

<style lang="scss" scoped>
.clientInfo {
  width: 377px;
  height: 100%;
  max-height: 442px;
  border-radius: 8px;
  border: 1px solid $border;
  background-color: $light-grey;
  .clientInfo__header {
    padding: 16px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom: 1px solid $border;
    background-color: $light-grey;
    p {
      font-family: 'Ubuntu-Medium';
      background-color: $light-grey;
    }
  }
  .clientInfo__main {
    margin: 16px;
    background-color: $light-grey;
    .info {
      margin-bottom: 25px;
      background-color: $light-grey;
      .ssn_btn {
        height: 16px !important;
        background-color: $light-grey;
      }
      p {
        color: $label;
        line-height: 14px;
        font-size: $twelveSize;
        background-color: $light-grey;
        padding-bottom: 7px;
      }
      span {
        color: $mid-grey;
        line-height: 14px;
        font-size: $fourteenSize;
        background-color: $light-grey;
      }
    }
    .consentGiven {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 25px;
      background-color: $light-grey;
      span {
        margin-left: 12px;
        font-size: $fourteenSize;
        line-height: $fourteenSize;
        font-weight: 500;
        font-family: 'Ubuntu-Medium';
        background-color: $light-grey;
      }
    }
  }
}
</style>
